export default {
  badge: '徽章',
  open: '開啟',
  close: '關閉',
  dismiss: '關閉',
  confirmEdit: {
    ok: '確定',
    cancel: '取消',
  },
  dataIterator: {
    noResultsText: '沒有符合條件的結果',
    loadingText: '讀取中...',
  },
  dataTable: {
    itemsPerPageText: '每頁列數：',
    ariaLabel: {
      sortDescending: '：降序排列。',
      sortAscending: '：升序排列。',
      sortNone: '無排序方式。點擊以升序排列。',
      activateNone: '點擊以移除排序方式。',
      activateDescending: '點擊以降序排列。',
      activateAscending: '點擊以移除排序方式。',
    },
    sortBy: '排序方式',
  },
  dataFooter: {
    itemsPerPageText: '每頁項目：',
    itemsPerPageAll: '全部',
    nextPage: '下一頁',
    prevPage: '上一頁',
    firstPage: '第一頁',
    lastPage: '最後頁',
    pageText: '{2} 條中的 {0}~{1} 條',
  },
  dateRangeInput: {
    divider: '至',
  },
  datePicker: {
    itemsSelected: '已選擇 {0} 個日期',
    range: {
      title: '選擇日期範圍',
      header: '輸入日期範圍',
    },
    title: '選擇日期',
    header: '輸入日期',
    input: {
      placeholder: '請輸入日期',
    },
    ariaLabel: {
      previousMonth: '上個月',
      nextMonth: '下個月',
      selectYear: '選擇年份',
      previousYear: '上一年',
      nextYear: '下一年',
      selectMonth: '選擇月份',
      selectDate: '{0}',
      currentDate: '今天，{0}',
    },
  },
  noDataText: '沒有資料',
  carousel: {
    prev: '上一張',
    next: '下一張',
    ariaLabel: {
      delimiter: '第 {0} 張 / 共 {1} 張',
    },
  },
  calendar: {
    moreEvents: '還有其他 {0} 項',
    today: '今天',
  },
  input: {
    clear: '清除 {0}',
    prependAction: '{0} 前置操作',
    appendAction: '{0} 附加操作',
    otp: '請輸入第 {0} 個 OTP 字元',
  },
  fileInput: {
    counter: '{0} 個檔案',
    counterSize: '{0} 個檔案（共 {1}）',
  },
  fileUpload: {
    title: '拖曳檔案至此',
    divider: '或',
    browse: '瀏覽檔案',
  },
  timePicker: {
    am: '上午',
    pm: '下午',
    title: '選擇時間',
    hour: '小時',
    minute: '分鐘',
    second: '秒',
  },
  pagination: {
    ariaLabel: {
      root: '分頁導航',
      next: '下一頁',
      previous: '上一頁',
      page: '轉到頁面 {0}',
      currentPage: '當前頁 {0}',
      first: '第一頁',
      last: '最後一頁',
    },
  },
  stepper: {
    next: '下一步',
    prev: '上一步',
  },
  rating: {
    ariaLabel: {
      item: '評分 {0} / {1}',
    },
  },
  loading: '載入中...',
  infiniteScroll: {
    loadMore: '載入更多',
    empty: '沒有更多內容',
  },
  rules: {
    required: '此欄位為必填項',
    email: '請輸入有效的電子郵件地址',
    number: '此欄位只能包含數字',
    integer: '此欄位只能包含整數',
    capital: '此欄位只能包含大寫字母',
    maxLength: '您最多可以輸入{0}個字符',
    minLength: '您必須至少輸入{0}個字符',
    strictLength: '輸入欄位的長度無效',
    exclude: '字符{0}是不允許的',
    notEmpty: '請至少選擇一個值',
    pattern: '格式無效',
  },
  hotkey: {
    then: '然後',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: '上箭頭',
    downArrow: '下箭頭',
    leftArrow: '左箭頭',
    rightArrow: '右箭頭',
    backspace: '退格',
    space: '空格',
    plus: '加',
    shortcut: '鍵盤快捷鍵：{0}',
    or: '或',
  },
  video: {
    play: '播放',
    pause: '暫停',
    seek: '搜尋',
    volume: '音量',
    showVolume: '顯示音量控制',
    mute: '靜音',
    unmute: '取消靜音',
    enterFullscreen: '全螢幕',
    exitFullscreen: '退出全螢幕',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: '從螢幕上選取顏色',
      hueSlider: '色相',
      alphaSlider: '透明度',
      redInput: '紅色',
      greenInput: '綠色',
      blueInput: '藍色',
      alphaInput: '透明度',
      hueInput: '色相',
      saturationInput: '飽和度',
      lightnessInput: '亮度',
      hexInput: '十六進位值',
      hexaInput: '帶透明度的十六進位值',
      changeFormat: '變更顏色格式',
    },
  },
}
